import { applyMiddleware, createStore } from 'redux';

// Load the root reducer for Redux
import RootReducer from './rootReducer';

// Load Redux middlewares
import { thunk } from 'redux-thunk';
import { createLogger } from 'redux-logger'

/**
 * Setup the Redux middlewares that will be attached to Redux actions
 */
const getMiddlewares = () => {

  // !!! ORDER OF APPLYING MIDDLEWARES IS VERY IMPORTANT !!!
  if (process.env.NODE_ENV === 'production') {
    return applyMiddleware(thunk);
  }

  // Not a production environment, apply development middlewares too.
  // NOTE: createLogger() MUST BE THE LAST MIDDLEWARE IN THE CHAIN SO IT WON'T LOG OTHER MIDDLEWARE ACTIVITY.
  const logger = createLogger({
    duration: true
  });
  return applyMiddleware(thunk, logger);
}

// Create a Redux store and apply the middlewares
const appStore = createStore(
  RootReducer,
  getMiddlewares()
);

export default appStore;
